import React from "react";
import { body, eyebrow, h2, section, shell } from "../utils/styles";
export function Story() {
  return <section id="historia" className={`${shell} ${section} grid gap-3 sm:grid-cols-2 sm:gap-10 lg:gap-20`} data-id="element-161" data-mp="1ibnexofa3xf8">
      <div data-id="element-162" data-mp="1n46s4ka20qji">
        <p className={eyebrow} data-id="element-163" data-mp="1n3nj5t2dtchm">Quién te acompaña</p>
        <h2 className={h2} data-id="element-164" data-mp="1s1yr1y949cx7">Aprender, implementar y seguir avanzando</h2>
      </div>
      <div className="sm:pt-10" data-id="element-165" data-mp="1s41jeoxqri53">
        <p className={`${body} mb-5 text-bright`} data-id="element-166" data-mp="uf9krc7dse5j">
          Soy papá de dos nenas y me apasionan las motos. Poder compartir tiempo con mi familia es una parte importante
          de por qué elegí emprender por internet.
        </p>
        <p className={`${body} mb-5`} data-id="element-167" data-mp="14b2vqr5gbzl7">
          Cuando empecé en el marketing digital, también tuve que aprender desde cero. Hoy comparto lo que aprendí para
          ayudarte a crear tu producto, preparar tu oferta y dar tus primeros pasos en la venta online.
        </p>
        <p className={body} data-id="element-168" data-mp="2jsd1fkhx8744">
          Eso es Radar Digital: formación y acompañamiento para pasar de mirar contenido a trabajar sobre tu propio
          proyecto.
        </p>
        <p className="pt-[15px] font-display text-lg text-lime" data-id="element-169" data-mp="142gtgygven5t">
          Marcos Rosell
          <small className="mt-[7px] block font-sans text-[11px] text-dim" data-id="element-170" data-mp="z3m0x4t3pk8i">Fundador de Radar Digital</small>
        </p>
      </div>
    </section>;
}